import { Inject, Injectable } from '@angular/core';
import { SubscriptionTierInterface, SubscriptionTiersService } from '@galaxy/partner';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, startWith, switchMap } from 'rxjs/operators';
import { PartnerService } from '../../core/partner.service';
import { TrialStatus } from '../../core/partner/partner-trial-status';
import { PartnerTrialStore, PartnerTrialStoreService } from '../../partner-trial';

/**
 * Maintains the state for the LevelBadgeComponent
 */
@Injectable()
export class LevelBadgeStoreService {
  subscriptionTier$: Observable<SubscriptionTierInterface>;
  showBadge$: Observable<boolean>;

  constructor(
    @Inject(PartnerTrialStoreService) private trials: PartnerTrialStore,
    @Inject(PartnerService) private partners: PartnerService,
    private readonly subscriptionTiersService: SubscriptionTiersService,
  ) {
    this.subscriptionTier$ = this.setUpSubscriptionLevel();
    this.showBadge$ = this.setUpShowBadge(this.subscriptionTier$);
  }

  private setUpSubscriptionLevel(): Observable<SubscriptionTierInterface> {
    return this.trials.partnerTrial$.pipe(
      switchMap((trial) => {
        if (trial.status === TrialStatus.ACTIVE) {
          return this.subscriptionTiersService.getSubscriptionTier(trial.subscriptionTierId, this.partners.partnerId);
        } else {
          return this.partners.subscriptionTier$;
        }
      }),
      shareReplay(1),
    );
  }

  private setUpShowBadge(subscriptionLevel: Observable<SubscriptionTierInterface>): Observable<boolean> {
    return subscriptionLevel.pipe(
      map((v) => v.tierVersion !== 'Classic'),
      startWith(false),
      distinctUntilChanged(),
      shareReplay(1),
    );
  }
}
